module.exports = __webpack_public_path__ + "static/media/overheating-engine.daf9cfbe.jpg";